import { render, staticRenderFns } from "./NotBack.vue?vue&type=template&id=aa257cb0&scoped=true"
import script from "./NotBack.vue?vue&type=script&lang=js"
export * from "./NotBack.vue?vue&type=script&lang=js"
import style0 from "./NotBack.vue?vue&type=style&index=0&id=aa257cb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa257cb0",
  null
  
)

export default component.exports